import { useState } from "react";
import { http, fmtErr } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AccountSecurity() {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [curPw, setCurPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [newPw2, setNewPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const saveName = async () => {
    if (!name.trim()) return toast.error("Name required");
    try {
      await http.put("/auth/profile", { name });
      toast.success("Name updated");
    } catch (e) { toast.error(fmtErr(e)); }
  };

  const changeEmail = async () => {
    if (!cur || !next) return toast.error("Enter your current password and new email");
    if (next !== confirm) return toast.error("New emails do not match");
    setBusy(true);
    try {
      const r = await http.post("/auth/change-email", { current_password: cur, new_email: next });
      toast.success(`Login email changed to ${r.data.email}. Use it next time you sign in.`);
      setCur(""); setNext(""); setConfirm("");
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };

  const changePw = async () => {
    if (!curPw || !newPw) return toast.error("Enter current and new password");
    if (newPw !== newPw2) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await http.post("/auth/change-password", { current_password: curPw, new_password: newPw });
      toast.success("Password changed");
      setCurPw(""); setNewPw(""); setNewPw2("");
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <div className="card" data-testid="account-profile">
        <h3 className="font-serif text-2xl mb-1">Owner Profile</h3>
        <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>Your display name shown across the admin panel.</p>
        <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Owner name</label>
        <input data-testid="owner-name" value={name} className="mb-3" onChange={(e) => setName(e.target.value)} />
        <button data-testid="owner-name-save" className="btn-primary" onClick={saveName}>Save Name</button>
      </div>

      <div className="card" data-testid="account-security">
        <h3 className="font-serif text-2xl mb-1">Change Login Email</h3>
        <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>Requires your current password. Your account, permissions and history are preserved.</p>
        <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Current password</label>
        <input data-testid="chgem-current" type="password" value={cur} className="mb-3" autoComplete="current-password" onChange={(e) => setCur(e.target.value)} />
        <div className="grid md:grid-cols-2 gap-3 mb-3">
          <div><label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>New login email</label>
            <input data-testid="chgem-new" type="email" value={next} autoComplete="off" onChange={(e) => setNext(e.target.value)} /></div>
          <div><label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Confirm new email</label>
            <input data-testid="chgem-confirm" type="email" value={confirm} autoComplete="off" onChange={(e) => setConfirm(e.target.value)} /></div>
        </div>
        <button data-testid="chgem-save" className="btn-primary" onClick={changeEmail} disabled={busy}>{busy ? "Updating…" : "Change Login Email"}</button>
      </div>

      <div className="card" data-testid="account-password">
        <h3 className="font-serif text-2xl mb-1">Change Password</h3>
        <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>Requires your current password. Minimum 8 characters.</p>
        <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Current password</label>
        <input data-testid="chgpw-current" type="password" value={curPw} className="mb-3" autoComplete="current-password" onChange={(e) => setCurPw(e.target.value)} />
        <div className="grid md:grid-cols-2 gap-3 mb-3">
          <div><label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>New password</label>
            <input data-testid="chgpw-new" type="password" value={newPw} autoComplete="new-password" onChange={(e) => setNewPw(e.target.value)} /></div>
          <div><label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Confirm new password</label>
            <input data-testid="chgpw-confirm" type="password" value={newPw2} autoComplete="new-password" onChange={(e) => setNewPw2(e.target.value)} /></div>
        </div>
        <button data-testid="chgpw-save" className="btn-primary" onClick={changePw} disabled={busy}>{busy ? "Updating…" : "Change Password"}</button>
      </div>
    </>
  );
}
